import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from groups.svg
 */
export default function GroupsIcon(props) {
  return _jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    "data-component": "GroupsIcon",
    ...props,
    children: _jsxs("g", {
      "fill-rule": "evenodd",
      children: [_jsx("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
      }), _jsx("path", {
        fill: "currentColor",
        d: "M2 14a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1a1 1 0 1 1-2 0v-1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1a1 1 0 1 1-2 0zM0 8a2.5 2.5 0 0 1 2.5-2.5H3a1 1 0 0 1 0 2h-.5A.5.5 0 0 0 2 8v1.5a1 1 0 1 1-2 0zM16 8a2.5 2.5 0 0 0-2.5-2.5H13a1 1 0 1 0 0 2h.5a.5.5 0 0 1 .5.5v1.5a1 1 0 1 0 2 0zM8 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M12.5 4.25a2 2 0 1 0 0-4 2 2 0 0 0 0 4M3.5 4.25a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
      })]
    })
  });
}
//# sourceMappingURL=Groups.js.map